import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ConversationThreadContext } from '#providers/conversations/Conversations.context.ts';
import type { TConversationThreadContextValue } from '#providers/conversations/Conversations.types.ts';

export const useConversationThread = (): TConversationThreadContextValue =>
  useRequiredContext(
    ConversationThreadContext,
    'useConversationThread is only available inside a ConversationsProvider',
  );
